import { BudgetCategoryView } from "../components";
import { EmergencyBudget, HousingBudget, SavingsBudget } from "../views";

import {
  EMERGENCY_BUDGET_CODE,
  HOUSING_BUDGET_CODE,
  SAVINGS_BUDGET_CODE,
} from "../constants";

export const slideConfigs = [
  {
    id: "savings-budget",
    title: "Save a portion of your income for...",
    budgetCategoryCode: SAVINGS_BUDGET_CODE,
    Component: SavingsBudget,
  },
  {
    id: "housing-budget",
    title: "Set up a home budget for...",
    budgetCategoryCode: HOUSING_BUDGET_CODE,
    Component: HousingBudget,
  },
  {
    id: "groceries-budget",
    title: "Your grocery budget for...",
    budgetCategoryCode: "GROCERIES",
    Component: BudgetCategoryView,
  },
  {
    id: "eating-out-budget",
    title: "Set up a restaurant budget for...",
    budgetCategoryCode: "EATING_OUT",
    Component: BudgetCategoryView,
  },
  {
    id: "transport-budget",
    title: "Set up a transportation budget for...",
    budgetCategoryCode: "TRANSPORT",
    Component: BudgetCategoryView,
  },
  {
    id: "phone-budget",
    title: "Set up a monthly phone budget for...",
    budgetCategoryCode: "PHONE",
    Component: BudgetCategoryView,
  },
  {
    id: "clothing-budget",
    title: "Set up a clothing budget for...",
    budgetCategoryCode: "CLOTHING",
    Component: BudgetCategoryView,
  },
  {
    id: "entertainment-budget",
    title: "Set up an entertainment budget for...",
    budgetCategoryCode: "ENTERTAIN",
    Component: BudgetCategoryView,
  },
  {
    id: "exercise-budget",
    title: "Set up an exercise budget for...",
    budgetCategoryCode: "EXERCISE",
    Component: BudgetCategoryView,
  },
  {
    id: "personal-care-budget",
    title: "Set up a self care budget for...",
    budgetCategoryCode: "PERS_CARE",
    Component: BudgetCategoryView,
  },
  {
    id: "treats-budget",
    title: "Set up a coffee budget for...",
    budgetCategoryCode: "TREATS",
    Component: BudgetCategoryView,
  },
  {
    id: "emergency-budget",
    title: "Something unexpected happened...",
    budgetCategoryCode: EMERGENCY_BUDGET_CODE,
    Component: EmergencyBudget,
  },
];
